import { FulfillmentOrderStatus, FulfillmentType } from '../../graphql'

export type StatusChipColor = 'default' | 'warning' | 'success' | 'error' | 'info' | 'primary' | 'secondary'

export const FO_STATUS_CHIP_COLOR: Record<FulfillmentOrderStatus, StatusChipColor> = {
	[ FulfillmentOrderStatus.Pending ]: 'warning',
	[ FulfillmentOrderStatus.SubmittedForFulfillment ]: 'info',
	[ FulfillmentOrderStatus.CancellationRequested ]: 'warning',
	[ FulfillmentOrderStatus.Cancelled ]: 'default',
	[ FulfillmentOrderStatus.Completed ]: 'success',
}

export const FO_STATUS_LABEL: Record<FulfillmentOrderStatus, string> = {
	[ FulfillmentOrderStatus.Pending ]: 'Pending',
	[ FulfillmentOrderStatus.SubmittedForFulfillment ]: 'In Progress',
	[ FulfillmentOrderStatus.CancellationRequested ]: 'Cancel Requested',
	[ FulfillmentOrderStatus.Cancelled ]: 'Cancelled',
	[ FulfillmentOrderStatus.Completed ]: 'Completed',
}

export const FO_TYPE_LABEL: Record<FulfillmentType, string> = {
	[ FulfillmentType.InventoryTransfer ]: 'Inventory Transfer',
	[ FulfillmentType.MttLoadout ]: 'MTT Loadout',
	[ FulfillmentType.DirectShipment ]: 'Direct Shipment',
}
